import SvgIcon from '@/components/svg-icon/svgIcon'
import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'

import { RoomOffer } from '../types'

type Props = {
	features: RoomOffer['amenities']
	description: string
}

export const RoomFeatures = ({ features, description }: Props) => {
	return (
		<>
			<div className={cn('md:mb-12')} dangerouslySetInnerHTML={{ __html: description }} />
			<div className={cn('flex flex-col gap-12')}>
				{features.map((ame) => (
					<div className={cn('flex gap-10')}>
						<SvgIcon
							collectionName="dsr-shared-room"
							iconName={ame.type}
							className="h-24 w-24"
						/>
						<div className={cn('flex flex-col gap-4')}>
							<Typography element="p" style="p-bold">
								{ame.name}
							</Typography>
							<Typography element="p" style="p">
								{ame.items.join(', ')}
							</Typography>
						</div>
					</div>
				))}
			</div>
		</>
	)
}
